import React from 'react';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Category,
  Footer,
} from '../../components';
import {Grid} from '@material-ui/core'

import css from './CategoryPage.module.css'


const CategoryPage = () => {
  // prettier-ignore
  return (
    <StaticPage
        title="Categories"
        schema={{
        "@context": "http://schema.org",
        "@type": "CategoryPage",
        "description": "Select yo",
        "name": "Categories selection"
        }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain className={css.mainWrapper}>
        <h1>Découvrez tous nos jardins</h1>
        <p>Sélectionnez la catégorie du jardin que vous recherchez pour un moment de détente ou pour cultiver votre bien-être et entretenir un potager.</p>
            <Category />
        </LayoutWrapperMain>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default CategoryPage